import * as React from 'react';
import { useIntl } from 'react-intl';

export default function BypassBlocks() {
    const { formatMessage } = useIntl();
    return (
        <>
            <a href="#main" className="sr-only">
                {formatMessage({ id: 'a11y.bypassBlocks.main' })}
            </a>
        </>
    );
}
